export default __webpack_public_path__ + "static/1120-751932cbbce34a288a3be0b0fabc306f.gif";